<template>
  <el-dialog
    v-el-dialog-drag
    show-close
    :visible.sync="visible"
    width="400px"
    :title="
      type === 'changeSales' ? $l('btn_changeSales') : $l('btn_changeBiz')
    "
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <el-form
      ref="form"
      :model="formData"
      label-position="left"
      label-width="100px"
    >
      <el-row>
        <el-form-item
          :label="
            type === 'changeSales'
              ? $l('INDEX.order_form_label_salesPersonCode')
              : $l('INDEX.order_form_label_bizPersonCode')
          "
          prop="userCode"
        >
          <dict-select
            clearable
            v-model="formData.userCode"
            filterable
            size="small"
            url="/master/common/dict/baseUserSelect"
            :placeholder="
              type === 'changeSales'
                ? $l('INDEX.form_label_please_select_a_business_person')
                : $l('INDEX.tips_select_bizPersonCode')
            "
            :selectedLabel.sync="formData.userName"
          ></dict-select>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">{{$l('INDEX.btn_cancel') || '取消'}}</el-button>
      <el-button type="primary" size="small" @click="confirmChange()">
        {{$l('INDEX.btn_confirm') || '确认'}}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {type: Boolean, default: false},
    type: {type: String, default: ''},
  },
  data() {
    return {
      formData: {
        userCode: '',
        userName: '',
      },
    }
  },
  methods: {
    async confirmChange() {
      if (!this.formData.userCode) {
        return this.$message.error(
          this.type === 'changeSales'
            ? this.$l('INDEX.form_label_please_select_a_business_person')
            : this.$l('INDEX.tips_select_bizPersonCode')
        )
      }

      const params = {
        type: this.type,
        userCode: this.formData.userCode,
        userName: this.formData.userName,
      }
      this.$emit('confirmChange', params)
      this.close()
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
